import React from 'react'

function FloorTwistOut() {
    return (
        <embed src="\pdfs\E1.3.1_DB-E-DN_Floor_twist_outlet_05.2015-1_kr.pdf" width="100%" height="2100px" />
    )
}

export default FloorTwistOut